import React, { useState } from 'react';
import axios from 'axios';
import { ArrowRight, CheckCircle2, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const emptyForm = { full_name: '', work_email: '', company: '', message: '' };

export const DemoForm = () => {
  const [form, setForm] = useState(emptyForm);
  const [status, setStatus] = useState('idle'); // idle | sending | sent | error
  const [error, setError] = useState('');

  const update = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    setError('');
    try {
      await axios.post(`${API}/demo-requests`, form);
      setStatus('sent');
      setForm(emptyForm);
    } catch (err) {
      setStatus('error');
      setError('We could not submit your request. Please try again or email info@bearer.ai.');
    }
  };

  if (status === 'sent') {
    return (
      <div className="form-success" data-testid="demo-form-success">
        <CheckCircle2 size={26} className="form-success-icon" />
        <span className="mono-label">Request received</span>
        <h3 className="display-medium">Thank you.</h3>
        <p className="body-large">
          We have your demo request. The Bountyplz team will review it and get back to you shortly.
        </p>
        <button className="btn-secondary" onClick={() => setStatus('idle')} data-testid="demo-form-reset-button">
          Send another request
        </button>
      </div>
    );
  }

  return (
    <form className="demo-form" onSubmit={submit} data-testid="demo-form">
      <div className="form-row">
        <label className="form-field">
          <span className="mono-label is-muted">Full name*</span>
          <input
            type="text"
            required
            value={form.full_name}
            onChange={update('full_name')}
            data-testid="demo-form-name-input"
          />
        </label>
        <label className="form-field">
          <span className="mono-label is-muted">Work email*</span>
          <input
            type="email"
            required
            value={form.work_email}
            onChange={update('work_email')}
            data-testid="demo-form-email-input"
          />
        </label>
      </div>

      <label className="form-field">
        <span className="mono-label is-muted">Company</span>
        <input
          type="text"
          value={form.company}
          onChange={update('company')}
          data-testid="demo-form-company-input"
        />
      </label>

      <label className="form-field">
        <span className="mono-label is-muted">What would you like tested?</span>
        <textarea
          rows={4}
          value={form.message}
          onChange={update('message')}
          data-testid="demo-form-message-input"
        />
      </label>

      <p className="body-small form-consent">
        Bountyplz LLC may use this information to contact you about products and services.
      </p>

      {status === 'error' && (
        <p className="form-error" data-testid="demo-form-error">{error}</p>
      )}

      <button
        type="submit"
        className="btn-primary"
        disabled={status === 'sending'}
        data-testid="demo-form-submit-button"
      >
        {status === 'sending' ? 'Sending' : 'Schedule a Demo'}
        {status === 'sending' ? <Loader2 size={16} className="spin" /> : <ArrowRight size={16} />}
      </button>
    </form>
  );
};
